<template>
  <div id="app" v-cloak>
    <TopNavBar></TopNavBar>
    <div class="router-content">
      <router-view></router-view>
    </div>
    <MyFooter></MyFooter>
  </div>
</template>
<script>
import TopNavBar from "@/components/home/TopNavBar";
import MyFooter from "@/components/detailPage/footer";
import NProgress from "nprogress"
import 'nprogress/nprogress.css'

import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  name: 'App',
  components: {MyFooter, TopNavBar},
  beforeCreate() {
    this.$router.beforeEach((to, from, next) => {
      NProgress.start()
      window.scroll({top:0})
      next()
    })
    this.$router.afterEach(() => {
      NProgress.done()
    })
  }
}
NProgress.start()
gsap.registerPlugin(ScrollTrigger)
</script>
<style>
[v-cloak] {
  display: none;
}
html{
  width: 100vw;
}
body{
  width: 100vw;
}
a {
  text-decoration: none;
}
#nprogress .bar {
  top:60px!important;
  background: white;
}
#nprogress .spinner {
  top:75px!important;
}
#nprogress .spinner-icon {
  border-top-color: white!important;
  border-left-color: white!important;
}
.router-content{
  margin-top: 60px;
}
body{
  margin: 0;
  background: #fae8e1;
  padding: 0;
}
@font-face {
  font-family: 'catalogfont';
  src: url('https://static.igem.wiki/teams/4152/wiki/wiki-res/font/silver.ttf') format('truetype');
}

@font-face {
  font-family: "normalfont";
  src:url("https://static.igem.wiki/teams/4152/wiki/wiki-res/font/04b-25.ttf") format('truetype');
}

@font-face {
  font-family: "article-normal";
  src: url("https://static.igem.wiki/teams/4152/wiki/wiki-res/font/manrope-regular.ttf") format('truetype');
}
.content-box h1{
  font-size: 28px;
  line-height: 28px;
  /* text-transform: capitalize; */
  color: #4978f3;
  text-shadow: 2px 2px 0px #F2DCDB;
}
.content-box h2{
  font-size: 23px;
  line-height: 24px;
  /* text-transform: capitalize; */
  color: #4978f3;
}
.content-box h3{
  font-size: 18px;
  line-height: 21px;
  /* text-transform: capitalize; */
  color: #4D75DB;
}
.content-box h4{
  font-size: 18px;
  line-height: 21px;
  /* text-transform: capitalize; */
}
.content-box h5{
  font-size: 17px;
  line-height: 21px;
  /* text-transform: capitalize; */
}
.content-box h6{
  font-size: 17px;
  line-height: 21px;
  /* text-transform: capitalize; */
}
.content-box p{
  font-size: 17px;
  line-height: 21px;
  text-indent:0.63cm;
  text-align:justify
}

.content-box li{
  font-size: 17px;
  line-height: 21px;
  text-align:justify
}
/*.content-box h1+p,.content-box h2+p,.content-box h3+p,.content-box h4+p,.content-box h5+p,.content-box h6+p{*/
/*  text-indent:unset;*/
/*}*/
.content-box a{
  font-size: 14px;
  line-height: 21px;
}
.article-img{
  text-align: center;
}
.article-img > img+p,.m-banner-wrap+p,.article-img iframe+p{
  text-align: center;
  font-size: 13px;
  line-height: 14px;
  font-weight: bold;
  text-indent: unset;
}
.article-img > img{
  width: 60%;
  object-fit: cover;
  transition: all 0.5s;
}
.article-img > img:hover{
  transform: translateY(-10px) scale(105%);
  box-shadow: 0px 10px 8px rgba(0,0,0,30%);
}
.article-table{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.article-table > p{
  text-align: center;
  font-size: 13px;
  line-height: 14px;
  font-weight: bold;
  text-indent: unset;
}
.content-box a{
  word-break: break-all;
  color: #4978f3;
}
.content-box a:visited{
  color: #4470e2;
}
.content-box a:after{
  content: "";
  background-image: url("https://static.igem.wiki/teams/4152/wiki/wiki-res/image/a-after.svg");
  height: 17px;
  width: 17px;
  display: inline-block;
  transform: translateY(4px);
}

.navs > li{
  padding: 0 20px;
  font-size: 28px;
  margin-bottom: 7px;
  margin-top: 7px;
  list-style: none;
}


@media screen and (max-width: 700px) {
  div.bg {
    display: none;
  }
  .content-box img{
    max-width: 60vw;
    object-fit: contain;
  }
}
</style>